module.exports = __webpack_public_path__ + "img/support.7a43112f.png";